module.exports = __webpack_public_path__ + "static/media/threatLocker.0fc16f37.jpg";